export const config = {
  "default": {
    firebase: {
      apiKey: "AIzaSyC2_5W0s8iY6KcKZRPilBR7a9uK1_ZLQhA",
      authDomain: "promoboxx-dev.firebaseapp.com",
      databaseURL: "https://promoboxx-dev.firebaseio.com",
      projectId: "promoboxx-dev",
      storageBucket: "promoboxx-dev.appspot.com",
      messagingSenderId: "289899694862"
    },
    lp_base_path: "https://lp-dev.firebaseapp.com",
    api_base_path: "http://api.local.promoboxx.com",
    cp_base_path: "http://cp.local.promoboxx.com",
    cloudinary_cloud_name: "pbxx-dev",
    facebook_app_id: '1607151679546301'
  },
  "dev-red": {
    firebase: {
      apiKey: "AIzaSyCY1trGfGgVZ9h0AzUs-oaV6I5wRnuPn_o",
      authDomain: "promoboxx-dev-red.firebaseapp.com",
      databaseURL: "https://promoboxx-dev-red.firebaseio.com",
      projectId: "promoboxx-dev-red",
      storageBucket: "promoboxx-dev-red.appspot.com",
      messagingSenderId: "180612153167"
    },
    api_base_path: "https://api.red.dev.promoboxx.com",
    cp_base_path: "http://cp.red.dev.promoboxx.com",
    cloudinary_cloud_name: "pbxx-dev",
    facebook_app_id: '1607151679546301'
  },
  "dev-black": {
    firebase: {
      apiKey: "AIzaSyA8W64DrKKLYuSYrhu3qEouFDRqOHu_1ck",
      authDomain: "promoboxx-dev-black.firebaseapp.com",
      databaseURL: "https://promoboxx-dev-black.firebaseio.com",
      projectId: "promoboxx-dev-black",
      storageBucket: "promoboxx-dev-black.appspot.com",
      messagingSenderId: "120021813066"
    },
    api_base_path: "https://api.black.dev.promoboxx.com",
    cp_base_path: "http://cp.black.dev.promoboxx.com",
    cloudinary_cloud_name: "pbxx-dev",
    facebook_app_id: '1607151679546301'
  },
  "dev-blue": {
    firebase: {
      apiKey: "AIzaSyCyOwQUYOvC6zb1sEqCCT5pU39Zd8wlGwQ",
      authDomain: "promoboxx-dev-blue.firebaseapp.com",
      databaseURL: "https://promoboxx-dev-blue.firebaseio.com",
      projectId: "promoboxx-dev-blue",
      storageBucket: "promoboxx-dev-blue.appspot.com",
      messagingSenderId: "548399848110"
    },
    api_base_path: "https://api.blue.dev.promoboxx.com",
    cp_base_path: "http://cp.blue.dev.promoboxx.com",
    cloudinary_cloud_name: "pbxx-dev",
    facebook_app_id: '1607151679546301'
  },
  "dev-green": {
    firebase: {
      apiKey: "AIzaSyCyejmkiiJycb9qdQcRzryuwMR3BLAqicA",
      authDomain: "promoboxx-dev-green.firebaseapp.com",
      databaseURL: "https://promoboxx-dev-green.firebaseio.com",
      projectId: "promoboxx-dev-green",
      storageBucket: "promoboxx-dev-green.appspot.com",
      messagingSenderId: "432509295227"
    },
    api_base_path: "https://api.green.dev.promoboxx.com",
    cp_base_path: "http://cp.green.dev.promoboxx.com",
    cloudinary_cloud_name: "pbxx-dev",
    facebook_app_id: '1607151679546301'
  },
  "dev-pink": {
    firebase: {
      apiKey: "AIzaSyCx2q7GNmcYzz8PWq6JTLbkL7Nvy5XUnps",
      authDomain: "promoboxx-dev-pink.firebaseapp.com",
      databaseURL: "https://promoboxx-dev-pink.firebaseio.com",
      projectId: "promoboxx-dev-pink",
      storageBucket: "promoboxx-dev-pink.appspot.com",
      messagingSenderId: "983764485253"
    },
    api_base_path: "https://api.pink.dev.promoboxx.com",
    cp_base_path: "http://cp.pink.dev.promoboxx.com",
    cloudinary_cloud_name: "pbxx-dev",
    facebook_app_id: '1607151679546301'
  },
  "dev-white": {
    firebase: {
      apiKey: "AIzaSyCOhWSonAyjJ0ZcjveznYKQmwwMZxRzQAs",
      authDomain: "promoboxx-dev-white.firebaseapp.com",
      databaseURL: "https://promoboxx-dev-white.firebaseio.com",
      projectId: "promoboxx-dev-white",
      storageBucket: "promoboxx-dev-white.appspot.com",
      messagingSenderId: "874227835427"
    },
    api_base_path: "https://api.white.dev.promoboxx.com",
    cp_base_path: "http://cp.white.dev.promoboxx.com",
    cloudinary_cloud_name: "pbxx-dev",
    facebook_app_id: '1607151679546301'
  },
  "dev-pine": {
    firebase: {
      apiKey: "AIzaSyBjp80wSGFKWpkhQjyXUKx0HT0ubYKMGDo",
      authDomain: "promoboxx-dev-pine.firebaseapp.com",
      databaseURL: "https://promoboxx-dev-pine.firebaseio.com",
      projectId: "promoboxx-dev-pine",
      storageBucket: "promoboxx-dev-pine.appspot.com",
      messagingSenderId: "791120035026"
    },
    lp_base_path: "https://lp-dev-pine.firebaseapp.com",
    api_base_path: "https://api.pine.dev.promoboxx.com",
    cp_base_path: "http://cp.pine.dev.promoboxx.com",
    cloudinary_cloud_name: "pbxx-dev",
    facebook_app_id: '1607151679546301'
  },
  "dev-maple": {
    firebase: {
      apiKey: "AIzaSyCjvDMT6CwzrozSqWihi_ajqrntrmnKI1M",
      authDomain: "promoboxx-dev-maple.firebaseapp.com",
      databaseURL: "https://promoboxx-dev-maple.firebaseio.com",
      projectId: "promoboxx-dev-maple",
      storageBucket: "promoboxx-dev-maple.appspot.com",
      messagingSenderId: "82338792689"
    },
    api_base_path: "https://api.maple.dev.promoboxx.com",
    cp_base_path: "http://cp.maple.dev.promoboxx.com",
    cloudinary_cloud_name: "pbxx-dev",
    facebook_app_id: '1607151679546301'
  },
  "staging": {
    firebase: {
      apiKey: "AIzaSyB3iLZ7_-rcA-KFhAO6vYbFPSHsmft9gxQ",
      authDomain: "promoboxx-stg.firebaseapp.com",
      databaseURL: "https://promoboxx-stg.firebaseio.com",
      projectId: "promoboxx-stg",
      storageBucket: "promoboxx-stg.appspot.com",
      messagingSenderId: "819018588187"
    },
    lp_base_path: "https://lp-stg.firebaseapp.com",
    api_base_path: "https://api.stg.promoboxx.com",
    cp_base_path: "https://cp.stg.promoboxx.com",
    cloudinary_cloud_name: "pbxx-staging",
    facebook_app_id: '1607151679546301'
  },
  "staging_new": {
    firebase: {
      apiKey: "AIzaSyB3iLZ7_-rcA-KFhAO6vYbFPSHsmft9gxQ",
      authDomain: "promoboxx-stg.firebaseapp.com",
      databaseURL: "https://promoboxx-stg.firebaseio.com",
      projectId: "promoboxx-stg",
      storageBucket: "promoboxx-stg.appspot.com",
      messagingSenderId: "819018588187"
    },
    lp_base_path: "https://lp-stg.firebaseapp.com",
    api_base_path: "https://api.stg.pbxx.io",
    cp_base_path: "https://cp.stg.pbxx.io",
    cloudinary_cloud_name: "pbxx-staging",
    facebook_app_id: '1607151679546301'
  },
  "production": {
    firebase: {
      apiKey: "AIzaSyBq6j7Y_ZCF35BQ_8_vvsU_Z_ZBks9B23g",
      authDomain: "promoboxx-production.firebaseapp.com",
      databaseURL: "https://promoboxx-production.firebaseio.com",
      projectId: "promoboxx-production",
      storageBucket: "promoboxx-production.appspot.com",
      messagingSenderId: "744204935007"
    },
    lp_base_path: "https://lp-prod.firebaseapp.com",
    api_base_path: "https://api.promoboxx.com",
    cp_base_path: "https://cp.promoboxx.com",
    cloudinary_cloud_name: "promoboxx",
    facebook_app_id: '104178376326712'
  }
}
